var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, forwardRef } from 'react';
import styled, { useTheme } from 'styled-components';
import Skeleton from '../../Progress/Skeleton/Skeleton';
import { useCronoSkeleton } from '../../Boost/CronoSkeleton';
import Label from '../Label/Label';
import Box from '../../Layout/Flex/Box';
const LabelStyle = styled.label `
    margin-right: ${props => props.label ? '0.5rem' : '0rem'};
    position: relative;
    display: inline-block;
    width: ${props => props.width};
    height: ${props => props.height};
        & input {
            opacity: 0;
            width: 0;
            height: 0;
        }
`;
const InputStyle = styled.input.attrs({ type: 'checkbox' }) `
    &:checked + .slider{
        background-color: ${props => props.isDisabled ? props.theme.colors.greyColor : props.theme.utils.getColor(props.color)}
    }
    &:focus + .slider{
        box-shadow: 0 0 1px ${props => props.theme.utils.getColor(props.theme.colors.mainLight)};
    }
    &:checked + .slider:before {
        -webkit-transform: translateX(97%);
        -ms-transform: translateX(97%);
        transform: translateX(97%);
    }
}
`;
const SpanStyle = styled.span `
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${props => props.isDisabled ? props.theme.colors.greyColor : props.theme.utils.getColorDark('dark')};
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 34px;
    &:before{
        position: absolute;
        content: "";
        height: 70%;
        width: 40%;
        left: 4px;
        bottom: 17%;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
        border-radius: 50%;
}
`;
const Switch = forwardRef((_a, ref) => {
    var { label, width = '40px', height = '24px', labelSize = 'note', register, name, noMargin = false, isChecked = false, isDisabled = false, onClick = () => { }, onChange = () => { }, errors = {}, color = 'main', labelColor, value, skeleton, excludeMeFromLoadingContext = false, isLoading = false, isLoadingLabel = false } = _a, props = __rest(_a, ["label", "width", "height", "labelSize", "register", "name", "noMargin", "isChecked", "isDisabled", "onClick", "onChange", "errors", "color", "labelColor", "value", "skeleton", "excludeMeFromLoadingContext", "isLoading", "isLoadingLabel"]);
    const [checked, setChecked] = useState(false);
    const theme = useTheme();
    const { loadingContext } = useCronoSkeleton();
    useEffect(() => {
        if (isChecked) {
            setChecked(true);
        }
        else if (!isChecked) {
            setChecked(false);
        }
    }, [isChecked]);
    const handleCheckboxChange = () => {
        if (!isDisabled) {
            onClick();
            setChecked(!checked);
            onChange(!checked);
        }
    };
    return _jsxs(Box, Object.assign({ alignItems: "center", style: { marginBottom: noMargin ? '0rem' : theme.spacings.halfSpacing }, width: 'auto' }, { children: [(loadingContext && excludeMeFromLoadingContext === false) || isLoading
                ? _jsx(Skeleton, Object.assign({ width: "46px", height: "26px" }, skeleton))
                : _jsxs(LabelStyle, Object.assign({ label: !!label, height: height, width: width, onClick: () => handleCheckboxChange }, props, { children: [_jsx(InputStyle, { isDisabled: isDisabled, color: color, name: name, ref: register, type: "checkbox", checked: checked, onChange: handleCheckboxChange, value: value }), _jsx(SpanStyle, { className: 'slider', isDisabled: isDisabled })] })), label &&
                _jsx(Label, { isLoading: isLoadingLabel && ((loadingContext && excludeMeFromLoadingContext === false) || isLoading), skeleton: { margin: 'h', width: '30px', style: { top: '2px' } }, label: label, labelSize: labelSize, color: labelColor || color, noMargin: true })] }));
});
export default Switch;
